import { ITabs_Types } from 'types/interfaces';

export const MODEL = 'MODEL';
export const EXAMPLE = 'EXAMPLE';

export const API_TABS: ITabs_Types = {
    [MODEL]: MODEL,
    [EXAMPLE]: EXAMPLE,
};
